module.exports = __webpack_public_path__ + "img/fat-lifting_hwmf10_c_scale,w_200-blur.a85ab844.jpg";